<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Edit Zone</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <ValidationForm :onSubmit="submit">
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="zone.name">
          </div>
          <!-- TODO Add Tags COMM-188 -->
          <div class="form-group">
            <label for="inpColor">Color</label>
            <color-picker id="inpColor" v-model="zone.color"></color-picker>
          </div>
          <div class="form-group" v-if="isMulticastZone">
            <label for="txtIp">IP</label>
            <input type="text" class="form-control" id="txtIp" v-model="zone.ip">
          </div>
          <div class="form-group" v-if="isMulticastZone">
            <label for="txtPort">Port</label>
            <input type="text" class="form-control" id="txtPort" v-model="zone.port">
          </div>
          <ValidationField
            v-if="!isVisualZone"
            id="txtExtension"
            label="Extension"
            helperText="Not required, but can only play from web interface if left at 6. If inputted, must keep leading 6 and follow with 3 numbers. Example: 6061"
            v-model="zone.extension"
            :validator="validate"
          ></ValidationField>
          <div class="form-group" v-if="!isVisualZone">
            <label for="txtHangupSeconds">Paging calls will auto hangup after x seconds</label>
            <input type="number" class="form-control" id="txtHangupSeconds" min="0" v-model="zone.hangup_seconds">
            <small class="form-text text-muted">0 for no hangup</small>
          </div>
          <button type="submit" class="btn btn-hub-primary" >Submit</button>
          <router-link :to="{ name: 'ZoneManager' }" class="btn btn-secondary">Cancel</router-link>
        </ValidationForm>
      </div>
      <div class="col-4">
        <CurrentExtensions default_type="zone"></CurrentExtensions>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Sketch } from 'vue-color'
import CurrentExtensions from '../../../components/CurrentExtensions'
import ValidationMixin from '../../../mixins/ValidationMixin.vue'
import { ZoneExtensionValidator } from '../../../assets/js/validators'
import { ZONE_TYPE } from '../../../assets/js/resource-types'

export default {
  props: [
    'zone_id'
  ],
  mixins: [ValidationMixin],
  computed: {
    ...mapGetters({
      zone: 'singleZone',
    }),
    isMulticastZone() {
      return this.zone.zone_type_id === ZONE_TYPE.Multicast
    },
    isVisualZone() {
      return this.zone.zone_type_id === ZONE_TYPE.Visual
    }
  },
  components: {
    'color-picker': Sketch,
    CurrentExtensions
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getZone', this.zone_id)
  },
  updated() {
    if(!this.initial_zone_extension && this.zone) this.initial_zone_extension = this.zone.extension
  },
  methods: {
    validate(value) {
      const validator = new ZoneExtensionValidator(this.extensions_in_use, this.initial_zone_extension)
      return validator.validate(value)
    },
    submit () {
      this.$store.dispatch('addEditZone', { zone: this.zone, next: 'ZoneManager' })
    }
  }
}
</script>

<style scoped>

</style>
